import EpisodeCard, { EpisodeCardProps } from './EpisodeCard';

export default EpisodeCard;
export type { EpisodeCardProps };
